export const columnasBanners = [
  {
    label: "ID",
    field: "id",
    sort: "asc",
    minimal: "lg",
    isVisible: false,
  },
  {
    label: "Título",
    field: "titulo",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Tipo",
    field: "tipo",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Alcance",
    field: "alcance",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Asignado",
    field: "asignado",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Estado",
    field: "estado",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Acciones",
    field: "acciones",
    sort: "disabled",
    minimal: "lg",
    isVisible: true,
  },
]; 